import { Controller } from "@hotwired/stimulus"

/**
 * Book → chapter cascade for picking where a question's source passage is
 * (docs/question-references.md). Loads the chapter list from the same JSON
 * endpoint the question generator's content-source picker uses.
 */
export default class extends Controller {
  static targets = ["book", "chapter"]
  static values = { url: String }

  connect() {
    if (this.bookTarget.value) this.load()
  }

  async load() {
    const bookId = this.bookTarget.value
    const select = this.chapterTarget
    select.innerHTML = ""
    select.disabled = true
    if (!bookId) {
      select.add(new Option("Select a book first…", ""))
      return
    }

    select.add(new Option("Loading…", ""))
    try {
      const response = await fetch(`${this.urlValue}?book_id=${encodeURIComponent(bookId)}`, {
        headers: { Accept: "application/json" }
      })
      const chapters = response.ok ? await response.json() : []
      select.innerHTML = ""
      select.add(new Option(chapters.length ? "Select a chapter…" : "No chapters you can read", ""))
      chapters.forEach((chapter) => select.add(new Option(chapter.name, chapter.id)))
      select.disabled = chapters.length === 0
    } catch (_) {
      select.innerHTML = ""
      select.add(new Option("Couldn't load chapters", ""))
    }
  }
}
